import { setReportData } from "../dailyTradeUXSlice";
import { setData } from "../dailyTradeDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { DailyTradingReportFilter } from "../types";

export const useCurrentTradesReportFilter = () => {
	const filter = useSelector<StoreType, DailyTradingReportFilter>(
		store => store.ux.reports.dailyTrade.filter
	);
	const dispatch = useDispatch();
	const dispatchSetReportDate = React.useCallback(
		(reportDate: string) => {
			dispatch(setReportData(reportDate));
			dispatch(setData());
		},
		[dispatch]
	);

	return [filter, dispatchSetReportDate] as [typeof filter, typeof dispatchSetReportDate];
};
